import {
  FETCHING_ROLODEX_CONTACTS_REQUEST,
  FETCHING_ROLODEX_CONTACTS_SUCCEDDED,
  FETCHING_ROLODEX_CONTACTS_FAILED,
  INVALIDATE_ROLODEX_CONTACTS,
  VIEW_CONTACT_REQUEST,
  INVALIDATE_CONTACT,
  FETCHING_CONTACT_ACTIVITY_REQUEST,
  FETCHING_CONTACT_ACTIVITY_SUCCEDDED,
  FETCHING_CONTACT_ACTIVITY_FAILED,
  FETCHING_CONTACT_SHARE_REQUEST,
  FETCHING_CONTACT_SHARE_SUCCEDDED,
  FETCHING_CONTACT_SHARE_FAILED,
  FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST,
  FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED,
  FETCHING_CONTACT_ASSET_ANALYTICS_FAILED,
  CREATING_CONTACT_REQUEST,
  CREATING_CONTACT_SUCCEDDED,
  CREATING_CONTACT_FAILED,
  UPDATING_CONTACT_REQUEST,
  UPDATING_CONTACT_SUCCEDDED,
  UPDATING_CONTACT_FAILED,
  DELETING_CONTACT_REQUEST,
  DELETING_CONTACT_SUCCEDDED,
  DELETING_CONTACT_FAILED,
  FETCHING_CONTACT_REQUEST,
  FETCHING_CONTACT_SUCCEDDED,
  FETCHING_CONTACT_FAILED,
  FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST,
  FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED,
  FETCHING_CONTACT_SHARES_ANALYTICS_FAILED,
  UNSUBSCRIBING_CONTACT_REQUEST,
  UNSUBSCRIBING_CONTACT_SUCCEDDED,
  UNSUBSCRIBING_CONTACT_FAILED,
  RESUBSCRIBING_CONTACT_REQUEST,
  RESUBSCRIBING_CONTACT_SUCCEDDED,
  RESUBSCRIBING_CONTACT_FAILED,
  FETCHING_CONTACT_SHARE_SECTION_REQUEST,
  FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED,
  FETCHING_CONTACT_SHARE_SECTION_FAILED,
  IMPORTING_CONTACTS_REQUEST,
  IMPORTING_CONTACTS_SUCCEDDED,
  IMPORTING_CONTACTS_FAILED,
} from "./actionTypes.jsx";
 
import axios from "axios"; 
import buildUrl from "build-url-ts"; 

const apiUrl = `${process.env.REACT_APP_API_URL}`;

export const ROLODEX_BASE_URL = `${apiUrl}/api/2.0/contacts`;
const SHARE_BASE_URL = `${apiUrl}/api/2.0/shares`;

export function fetchContacts(global, page, query) {
  return function (dispatch) {
    dispatch(fetchingContacts());

    let param = {
      query: query,
      page: page,
      global: global,
    };

    return axios({
      method: "GET",
      url: ROLODEX_BASE_URL,
      params: param,
    })
      .then((response) => {
        return dispatch(fetchingContactsSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(fetchingContactsFailed(error));
      });
  };
}

function fetchingContacts() {
  return {
    type: FETCHING_ROLODEX_CONTACTS_REQUEST,
    payload: {},
  };
}

function fetchingContactsSuccedded(json) {
  return {
    type: FETCHING_ROLODEX_CONTACTS_SUCCEDDED,
    payload: json,
  };
}

function fetchingContactsFailed(error) {
  console.log(error);

  return {
    type: FETCHING_ROLODEX_CONTACTS_FAILED,
    payload: error,
  };
}

export function invalidateContacts() {
  return {
    type: INVALIDATE_ROLODEX_CONTACTS,
    payload: {},
  };
}

export function invalidateContact() {
  return {
    type: INVALIDATE_CONTACT,
    payload: {},
  };
}

export function shouldFetchContacts(state) {
  let resource = state.legacyRootReducer.rolodex;

  if (!resource.items) {
    return true;
  } else if (resource.loading) {
    return false;
  } else {
    return resource.invalidated;
  }
}

export function viewContact(id) {
  return function (dispatch) {
    dispatch(viewingContact(id));
  };
}

function viewingContact(id) {
  return {
    type: VIEW_CONTACT_REQUEST,
    payload: id,
  };
}

export function fetchContactShareAnanlytics(id, page) {
  return function (dispatch) {
    dispatch(fetchingContactShareAnanlyticsRequest(id));

    let param = {
      page: page,
    };

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${id}/shares`,
    });

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(
          fetchingContactShareAnanlyticsSuccedded(id, response.data)
        );
      })
      .catch((error) => {
        return dispatch(fetchingContactShareAnanlyticsFailed(id, error));
      });
  };
}

function fetchingContactShareAnanlyticsRequest(id) {
  return {
    type: FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST,
    payload: { id },
  };
}

function fetchingContactShareAnanlyticsSuccedded(id, json) {
  return {
    type: FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED,
    payload: {
      id: id,
      shares: json,
    },
  };
}

function fetchingContactShareAnanlyticsFailed(id, error) {
  console.log(error);

  return {
    type: FETCHING_CONTACT_SHARES_ANALYTICS_FAILED,
    payload: {
      id: id,
      error: error,
    },
  };
}

export function fetchAssetAnalytics(contactID, shareID, sectionID, assetID) {
  return function (dispatch) {
    dispatch(fetchingAssetAnalytics(contactID, shareID, sectionID, assetID));

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${contactID}/shares/${shareID}/assets/${assetID}/analytics`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => {
        return dispatch(
          fetchingAssetAnalyticsSuccedded(
            contactID,
            shareID,
            sectionID,
            assetID,
            response.data
          )
        );
      })
      .catch((error) => {
        return dispatch(
          fetchingAssetAnalyticsFailed(
            contactID,
            shareID,
            sectionID,
            assetID,
            error
          )
        );
      });
  };
}

function fetchingAssetAnalytics(contactID, shareID, sectionID, assetID) {
  return {
    type: FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST,
    payload: {
      contact: contactID,
      share: shareID,
      section: sectionID,
      asset: assetID,
    },
  };
}

function fetchingAssetAnalyticsSuccedded(
  contactID,
  shareID,
  sectionID,
  assetID,
  json
) {
  return {
    type: FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED,
    payload: {
      contact: contactID,
      share: shareID,
      section: sectionID,
      asset: assetID,
      analytics: json,
    },
  };
}

function fetchingAssetAnalyticsFailed(
  contactID,
  shareID,
  sectionID,
  assetID,
  error
) {
  return {
    type: FETCHING_CONTACT_ASSET_ANALYTICS_FAILED,
    payload: {
      contact: contactID,
      share: shareID,
      section: sectionID,
      asset: assetID,
      error: error,
    },
  };
}

export function getContactForEmail(state, email) {
  if (state.legacyRootReducer.rolodex.items) {
    return state.legacyRootReducer.rolodex.items.find((contact) => {
      return contact.email == email;
    });
  }
}

export function createContact(contact) {
  return function (dispatch) {
    dispatch(creatingContact());

    return axios({
      method: "POST",
      url: ROLODEX_BASE_URL,
      data: contact,
    })
      .then((response) => {
        return dispatch(creatingContactSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(creatingContactFailed(error));
      });
  };
}

function creatingContact() {
  return {
    type: CREATING_CONTACT_REQUEST,
    payload: {},
  };
}

function creatingContactSuccedded(json) {
  return {
    type: CREATING_CONTACT_SUCCEDDED,
    payload: json,
  };
}

function creatingContactFailed(error) {
  return {
    type: CREATING_CONTACT_FAILED,
    payload: error,
  };
}

export function updateContact(contact) {
  return function (dispatch) {
    dispatch(updatingContact());

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${contact.id}`,
    });

    return axios({
      method: "PUT",
      url: url,
      data: contact,
    })
      .then((response) => {
        return dispatch(updatingContactSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(updatingContactFailed(error));
      });
  };
}

function updatingContact() {
  return {
    type: UPDATING_CONTACT_REQUEST,
    payload: {},
  };
}

function updatingContactSuccedded(json) {
  return {
    type: UPDATING_CONTACT_SUCCEDDED,
    payload: json,
  };
}

function updatingContactFailed(error) {
  return {
    type: UPDATING_CONTACT_FAILED,
    payload: error,
  };
}

export function deleteContact(contactList, id) {
  return function (dispatch) {
    dispatch(deletingContact());

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${id}`,
    });

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        return dispatch(deletingContactSuccedded(contactList, response.data));
      })
      .catch((error) => {
        return dispatch(deletingContactFailed(error));
      });
  };
}

function deletingContact() {
  return {
    type: DELETING_CONTACT_REQUEST,
    payload: {},
  };
}

function deletingContactSuccedded(contactList, json) {
  return {
    type: DELETING_CONTACT_SUCCEDDED,
    payload: {
      contactList: contactList,
      response: json
    },
  };
}

function deletingContactFailed(error) {
  console.log(error);
  return {
    type: DELETING_CONTACT_FAILED,
    payload: error,
  };
}

export function fetchContact(id) {
  return function (dispatch) {
    dispatch(fetchingContact(id));

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${id}`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => {
        return dispatch(fetchingContactSuccedded(id, response.data));
      })
      .catch((error) => {
        return dispatch(fetchingContactFailed(id, error));
      });
  };
}

function fetchingContact(id) {
  return {
    type: FETCHING_CONTACT_REQUEST,
    payload: { id },
  };
}

function fetchingContactSuccedded(id, json) {
  return {
    type: FETCHING_CONTACT_SUCCEDDED,
    payload: {
      id: id,
      contact: json,
    },
  };
}

function fetchingContactFailed(id, error) {
  console.log(error);
  return {
    type: FETCHING_CONTACT_FAILED,
    payload: {
      id: id,
      error: error,
    },
  };
}

/**
 * Lite
 */


export function fetchSharesByOpportunityId(id) {
  return function (dispatch) {
    dispatch(fetchingContact(id));
    return;
  };
}

export function unsubscribeContact(contactId, conversationId, contactKey) {
  return function (dispatch) {
    dispatch(unsubscribingContactRequest());

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${contactId}/unsubscribe`,
    });

    let param = {
      token: contactKey,
      conversation: conversationId,
    };

    return axios({
      method: "PUT",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(unsubscribingContactSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(unsubscribingContactFailed(error));
      });
  };
}

function unsubscribingContactRequest() {
  return {
    type: UNSUBSCRIBING_CONTACT_REQUEST,
    payload: {},
  };
}

function unsubscribingContactSuccedded(json) {
  return {
    type: UNSUBSCRIBING_CONTACT_SUCCEDDED,
    payload: json,
  };
}

function unsubscribingContactFailed(error) {
  return {
    type: UNSUBSCRIBING_CONTACT_FAILED,
    payload: error,
  };
}

export function resubscribeContact(contactId, conversationId, contactKey) {
  return function (dispatch) {
    dispatch(resubscribingContactRequest());

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `${contactId}/resubscribe`,
    });

    let param = {
      token: contactKey,
      conversation: conversationId,
    };

    return axios({
      method: "PUT",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(resubscribingContactSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(resubscribingContactFailed(error));
      });
  };
}

function resubscribingContactRequest() {
  return {
    type: RESUBSCRIBING_CONTACT_REQUEST,
    payload: {},
  };
}

function resubscribingContactSuccedded(json) {
  return {
    type: RESUBSCRIBING_CONTACT_SUCCEDDED,
    payload: json,
  };
}

function resubscribingContactFailed(error) {
  return {
    type: RESUBSCRIBING_CONTACT_FAILED,
    payload: error,
  };
}

/**
 * Fetch share for given id
 */
export function fetchShareForContact(contactId, shareId) {
  return function (dispatch) {
    dispatch(fetchingShareForContact(contactId, shareId));

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `/${contactId}/shares/${shareId}`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(fetchingShareForContactSuccedded(contactId, response.data))
      )
      .catch((error) =>
        dispatch(fetchingShareForContactFailed(contactId, shareId, error))
      );
  };
}

function fetchingShareForContact(contactId, shareId) {
  return {
    type: FETCHING_CONTACT_SHARE_REQUEST,
    payload: {
      contact: contactId,
      share: shareId,
    },
  };
}

function fetchingShareForContactSuccedded(contactId, json) {
  return {
    type: FETCHING_CONTACT_SHARE_SUCCEDDED,
    payload: {
      contact: contactId,
      share: json,
    },
  };
}

function fetchingShareForContactFailed(contactId, shareId, error) {
  return {
    type: FETCHING_CONTACT_SHARE_FAILED,
    payload: {
      contact: contactId,
      share: shareId,
      error: error,
    },
  };
}

/**
 * Fetch share section for given id
 */
export function fetchShareSection(contactId, shareId, sectionId) {
  return function (dispatch) {
    dispatch(fetchingShareSection(contactId, shareId, sectionId));

    let url = buildUrl(ROLODEX_BASE_URL, {
      path: `/${contactId}/sections/${sectionId}`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(
          fetchingShareSectionSuccedded(contactId, shareId, response.data)
        )
      )
      .catch((error) =>
        dispatch(
          fetchingShareSectionFailed(contactId, shareId, sectionId, error)
        )
      );
  };
}

function fetchingShareSection(contactId, shareId, sectionId) {
  return {
    type: FETCHING_CONTACT_SHARE_SECTION_REQUEST,
    payload: {
      contact: contactId,
      share: shareId,
      section: sectionId,
    },
  };
}

function fetchingShareSectionSuccedded(contactId, shareId, json) {
  return {
    type: FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED,
    payload: {
      contact: contactId,
      share: shareId,
      section: json,
    },
  };
}

function fetchingShareSectionFailed(contactId, shareId, sectionId, error) {
  return {
    type: FETCHING_CONTACT_SHARE_SECTION_FAILED,
    payload: {
      contact: contactId,
      share: shareId,
      section: sectionId,
      error: error,
    },
  };
}

/**
 * Bulk import contacts
 */
export function importContacts(contacts) {
  return function (dispatch) {
    dispatch(importingContacts(contacts));

    return axios({
      method: "POST",
      url: `${ROLODEX_BASE_URL}/bulk`,
      data: contacts,
    })
      .then((response) => dispatch(importContactsSuccedded(response.data)))
      .catch((error) => dispatch(importContactsFailed(error)));
  };
}

function importingContacts(contacts) {
  return {
    type: IMPORTING_CONTACTS_REQUEST,
    payload: {
      contact: contacts,
    },
  };
}

function importContactsSuccedded(json) {
  return {
    type: IMPORTING_CONTACTS_SUCCEDDED,
    payload: {
      contacts: json,
    },
  };
}

function importContactsFailed(error) {
  return {
    type: IMPORTING_CONTACTS_FAILED,
    payload: {
      error: error,
    },
  };
}

export function fetchContactByEmail(email) {
  return function (dispatch) {
    dispatch(fetchingContact(email));

    return axios({
      method: "GET",
      url: `${ROLODEX_BASE_URL}/email?email=${email}`,
    })
      .then((response) => {
        return dispatch(
          fetchingContactSuccedded(response.data.id, response.data)
        );
      })
      .catch((error) => {
        return dispatch(fetchingContactFailed(email, error));
      });
  };
}